import React from 'react'
import HeaderIcons from '../../shared/HeaderIcons'
import { HorizontalBar } from 'react-chartjs-2'

type Props = {
    Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    title: string;
    value: number | string;
    projectsLabel: string;
    data: any;
    options: any;
};

const GcmChartCard: React.FC<Props> = ({ Icon, title, value, projectsLabel, data, options }) => {

    return (
        <>
            <div className="chart-card-early">
                <div className='gcmAlerts-title'>
                    <HeaderIcons Icon={Icon} text=" " />
                    <p>
                        <b>{title} |</b> {value} {projectsLabel}
                    </p>
                </div>
                <div>
                    <HorizontalBar data={data} options={options} />
                </div>
            </div>
        </>
    )
}

export default GcmChartCard